import styled, { css, keyframes } from 'styled-components'

import { cases } from '@subaio/utils'

import { type AnimationProps, type AnimationRender, AnimationStatus } from '../useKeyedAnimation'

const animation = keyframes`
	0% {
		background-color: transparent;
	}
`

export type ModalShadowRender = AnimationRender<{ onClick: (() => void) | undefined }>

export const ModalShadow = styled.div<AnimationProps>`
	position: absolute;
	inset: 0;
	background-color: #000000b2;

	@supports ((-webkit-backdrop-filter: blur(3px)) or (backdrop-filter: blur(3px))) {
		backdrop-filter: blur(3px);
		background-color: #0009;
	}

	${({ status, duration }) =>
		cases(status, {
			[AnimationStatus.Entering]: css`
			animation: ${duration}s ${animation};
		`,
			[AnimationStatus.Exiting]: css`
			backdrop-filter: none;
			animation: ${duration}s ${animation} reverse forwards;
		`,
		})}
`

export const renderModalShadow: ModalShadowRender = {
	content: (key, props) => <ModalShadow key={key} {...props} />,
	duration: 0.15,
}
